import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSlug } from '../config/routes/guards/slug';
import axios from '../library/axios';

/**
 * Custom hook untuk mengatur document title secara dinamis
 * - Jika tidak ada slug: "Speak by Lamkprs"
 * - Jika ada slug: "Speak by Lamkprs | {namaRs}"
 * 
 * Title akan di-update ketika:
 * - Component mount
 * - Route berubah (location change)
 * - Slug berubah
 * 
 * Note: Hook ini harus dipanggil di dalam Router component
 */
export const useDocumentTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const slug = getSlug();
    
    if (!slug) {
      // Tidak ada slug, gunakan title default
      document.title = 'Speak by Lamkprs';
      return;
    }

    // Ada slug, fetch profile untuk mendapatkan namaRs
    const fetchProfileAndSetTitle = async () => {
      try {
        const options = {
          url: `/profile/list`,
          method: 'GET',
          headers: {
            'Access-Control-Allow-Origin': '*',
          },
        };
        const response = await axios(options);
        const data = response.data;
        
        if (data && Array.isArray(data) && data.length > 0 && data[0].namaRs) {
          // Gunakan namaRs sebagai tenant description
          const newTitle = `Speak by Lamkprs | ${data[0].namaRs}`;
          document.title = newTitle;
        } else {
          // Fallback jika profile belum ada
          document.title = 'Speak by Lamkprs';
        }
      } catch (err) {
        // Jika error, gunakan title default
        // Jangan log error jika belum login (401/403 adalah normal)
        if (err?.response?.status !== 401 && err?.response?.status !== 403) {
          console.log('Error fetching profile for title:', err?.response?.data || err?.message || err);
        }
        document.title = 'Speak by Lamkprs';
      }
    };

    // Small delay to ensure slug is available
    const timer = setTimeout(() => {
      fetchProfileAndSetTitle();
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname, location.search]); // Update ketika route atau query berubah
};

